export const authDenialReasons = ['access_denied', 'email_not_verified', 'agreements_not_accepted'] as const;

export type AuthDenialReason = (typeof authDenialReasons)[number];
